import Footer from "../components/Footer";
import Header from "../components/Header";
import sanpham from "@/assets/img/sanpham/1.png";
const SanPham = () => {
  return (
    <div className="wrapper">
      <div className="container-web muctieu bgnew">
        <Header title="Sản phẩm" />

        <main className="px-3">
          <div className="box-content">
            <p className="text-center">
              TẬP ĐOÀN DOJI: Trái Phiếu Tiết Kiệm Nội Bộ
            </p>
            <p>
              <img className="w-100" src={sanpham} />
            </p>

            <p>1. Tổng Quan Về Trái Phiếu</p>

            <p>
              Gửi tiết kiệm trái phiếu : Tập trung vào việc gửi tiết kiệm trái
              phiếu vào tập đoàn DOJI và các công ty con thuộc tập đoàn. Mục
              tiêu của việc gửi tiết kiệm trái phiếu là sử dụng vốn để hỗ trợ
              các dự án và hoạt động của DOJI, từ đó tạo ra lợi nhuận cao cho
              người nắm trái phiếu thông qua việc phân phối lợi nhuận thu được
              từ các hoạt động của tập đoàn.
            </p>

            <p>2. Cách Thức Hoạt Động</p>

            <p>
              Gửi tiết kiệm trái phiếu : Tập đoàn DOJI sẽ phát hành trái phiếu
              hoặc các công ty con của tập đoàn. Các khoản đầu tư này có thể bao
              gồm việc phát hành trái phiếu trực tiếp hoặc đầu tư vào các dự án
              cụ thể mà tập đoàn đang triển khai.
            </p>
            <p>
              Gửi tiết kiệm trái phiếu: Tập đoàn DOJI sử dụng số tiền gửi trái
              phiếu để phát triển các dự án lớn, bao gồm bất động sản, du lịch,
              nhà hàng, tài chính ngân hàng các dự án này có khả năng sinh lợi
              nhuận cao và tạo ra giá trị gia tăng cho tập đoàn.
            </p>

            <p>3. Phân Bổ Vốn</p>
            <p>
              Trái phiếu tập đoàn: Một số vốn sẽ được đầu tư vào sản suất vàng,
              trang sức, kim cương và các công ty con của tập đoàn trên thị
              trường. Một số vốn sẽ được đầu tư vào các dự án của tập đoàn DOJI
              như: Tài chính ngân hàng, Dự án bất động sản, dịch vụ nhà hàng,
              khai thác đá quý , chế tạo đá quý và du lịch hoặc các dịch vụ mới.
            </p>
            <p>
              Quản lý rủi ro: Trái phiếu sẽ được phân bố vốn và điểu chỉnh dựa
              trên hiệu suất và tiềm năng sinh lời từ lĩnh vực đầu tư để đảm bảo
              tính rủi ro luôn ở mức thấp nhất.
            </p>
            <p>4. Minh Bạch Và Báo Cáo</p>
            <p>
              Báo cáo định kỳ: Người nắm trái phiếu sẽ nhận được báo cáo hàng
              tháng hoặc hàng quý về tình hình đầu tư, bao gồm thông tin chi
              tiết về danh mục đầu tư, hiệu suất của trái phiếu DOJI, và kết quả
              từ các dự án cụ thể.
            </p>
            <p>
              Thông tin dự án: Cung cấp thông tin chi tiết về các dự án mà DOJI
              đang đầu tư, bao gồm tiến độ dự án, dự báo lợi nhuận, và các rủi
              ro tiềm ẩn.
            </p>
            <p>
              Nhóm quản lý: Công khai thông tin về đội ngũ quản lý quỹ và các
              chuyên gia đầu tư chịu trách nhiệm về chiến lược đầu tư và quản lý
              rủi ro.
            </p>
            <p>5. Lợi Nhuận Của Trái Phiếu</p>
            <p>
              Lợi nhuận từ trái phiếu: Người nắm trái phiếu sẽ nhận được lợi
              nhuận từ việc tăng lãi suất và chi trả lãi suất ở các dự án của
              tập đoàn DOJI.
            </p>
            <p>
              Lợi nhuận từ dự án: Lợi nhuận từ các dự án đầu tư sẽ được phân
              phối cho nhà đầu tư theo tỷ lệ trái phiếu. Lợi nhuận này có thể
              được tính toán dựa trên doanh thu và lợi nhuận của các dự án cụ
              thể.
            </p>
            <p>6. VÍ Dụ Cụ Thể</p>
            <p>
              Gửi tiết kiệm trái phiếu: Người nắm giữ trái phiếu 10.000.000 VND
              của tập đoàn, nếu trái tức của tập đoàn tăng 0.4% trong ngày,
              người nắm trái phiếu có thể nhận lợi nhuận 40.000 VND từ khoản
              này.
            </p>
            <p>
              Gửi tiết kiệm trái phiếu: Người nắm trái phiếu 20.000.000 VND có
              kỳ hạn từ 45-90 ngày vào dự án tập đoàn DOJI. Dự kiến dự án này sẽ
              mang lại lợi nhuận 0.4% trong vòng 45-90 ngày, tức là
              3.600.000-7.200.000 VND lợi nhuận cho người nắm trái phiếu.
            </p>
            <p>7. Cam Kết An Toàn</p>
            <p>
              Quản lý rủi ro trái phiếu: Lợi nhuận này có thể được tính toán dựa
              trên doanh thu và lợi nhuận của các dự án cụ thể.
            </p>
            <p>
              Bảo mật thông tin: Tất cả thông tin liên quan đến đầu tư và lợi
              nhuận được bảo mật và chỉ có người nắm trái phiếu mới có quyền
              truy cập.
            </p>
            <p>Kết Luận</p>
            <p>
              Việc gửi tiết kiệm trái phiếu vào tập đoàn DOJI và các dự án công
              ty con của tập đoàn có thể mang lại lợi nhuận cao nếu tập đoàn
              phát triển mạnh mẽ và các dự án của tập đoàn thành công. Tuy nhiên
              cần đảm bảo rằng quý khách cung cấp thông tin minh bạch về các
              khoản đầu tư và kết quả của các dự án để tạo sự tin tưởng và an
              tâm cho người nắm trái phiếu. Sự rõ ràng trong cách thức hoạt động
              của tập đoàn cam kết về quản lý rủi ro sẽ giúp quý khách thu hút
              và giữ chân các nhà đầu tư.
            </p>
            <div className="mb-2">
              <strong>
                <span style={{ color: "#2880b9" }}>
                  <a style={{ color: "#2880b9" }} href="https://doji.vn/">
                    Thông tin về tập đoàn: https://doji.vn/
                  </a>
                </span>
              </strong>
            </div>
          </div>

          <div style={{ paddingBottom: 120 }}></div>
        </main>

        <Footer />
      </div>
    </div>
  );
};

export default SanPham;
